import Header from "./components/Header";
// import Tesmonials from "./components/Tesmonials";

import {BrowserRouter as Router } from 'react-router-dom'
import Footer from "./components/Footer"
import Main from "./components/main"




function App() {
  return (
    <Router >
              <div className="max-w-4xl mx-auto p-2 ">
                
                  <Header /> 
                  <Main/>
                  <Footer/>
              </div>
              
   </Router>
  );
}

export default App;
